export async function proposeKambiBetAsync(): Promise<void> {
  // ProposeBet()
  try {
    // TODO: Handle kambi sports bet
  } catch {
    // TODO: Handle errors
  }
}

export async function confirmKambiBetAsync(): Promise<void> {
  // ConfirmBet()
  try {
    // TODO: Handle kambi sports bet
  } catch {
    // TODO: Handle errors
  }
}
